import { Dialog, DialogContent } from "@mui/material";
import RainbowText from "components/RainbowText";
import { useEffect, useMemo, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { fetchAiChatMessages, selectLensEditorAiChatWithMessages } from "redux/slices/lensEditor";

function PromptViewer({
  chatId,
  lensId,
  setPromptId,
}: {
  chatId: string;
  lensId: number;
  setPromptId: (id: string | undefined) => void;
}) {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const chatWithMessages = useAppSelector(selectLensEditorAiChatWithMessages);
  useEffect(() => {
    if (chatWithMessages === undefined || chatWithMessages.chat.id !== chatId) {
      setLoading(true);
      dispatch(fetchAiChatMessages({ chatId, lensId })).finally(() => setLoading(false));
    }
  }, [chatId]);

  const relevantText = useMemo(() => {
    const blocksMessage = chatWithMessages?.messages.find((message) => message.format.__typename === "Blocks");
    if (blocksMessage && blocksMessage.content) return blocksMessage.content;

    const pageImageMessage = chatWithMessages?.messages.find((message) => message.format.__typename === "PageImage");
    if (pageImageMessage && pageImageMessage.contentParts) {
      return pageImageMessage.contentParts.map((part) => part.textContent).join("");
    }

    return "Unable to find block text";
  }, [chatWithMessages]);

  if (loading) return null;

  return <PromptViewerDisplay key={chatId} blockContent={relevantText} close={() => setPromptId(undefined)} />;
}

function PromptViewerDisplay({ blockContent, close }) {
  return (
    <Dialog fullWidth maxWidth="lg" open={true} onClose={close}>
      <DialogContent>
        <RainbowText
          sx={{ fontFamily: "monospace", whiteSpace: "pre-wrap" }}
          annotations={[]}
          text={blockContent || ""}
        />
      </DialogContent>
    </Dialog>
  );
}

export default PromptViewer;
